import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Puzzle} from './puzzle.js';
import {RNG} from '../utils/rng.js';
import {PuzzleUtils} from '../classes/PuzzleUtils.js';
import {BlobPrefabs} from './blob-prefabs.js';

export class BlobInjector extends Component {
    static TypeName = 'blob-injector';

    @property.string('name from BlobPrefabs/pieces.wlp')
    prefabToInject: string;

    @property.string('')
    prefabTag = '';

    @property.int(3)
    minTurnsBeforeInjection = 3;

    @property.int(9)
    maxTurnsBeforeInjection = 9;

    @property.float(0.2)
    minimumRequiredQuality = 0.2;

    @property.int(3)
    numberToSpawnOnStartup = 1;

    @property.int(0)
    minimumLevelToSpawn = 0;

    @property.int(0)
    maximumLevelToSpawn = 0;

    private _turnCount: number = 0;
    private _nextInjectTurn: number = 0;

    private _minTurnsBeforeInjection: number = 0;
    private _maxTurnsBeforeInjection: number = 0;
    private _numberToSpawnOnStartup: number = 0;

    private static readonly SEARCH_SIZE = 5;

    start() {
        const puzzle = Puzzle.instance;
        // puzzle.registerTurnCompleteCallback(this._turn);
        // puzzle.registerResetGameCallback(this._reset);
        this._turnCount = 0;

        this._minTurnsBeforeInjection = this.minTurnsBeforeInjection;
        this._maxTurnsBeforeInjection = this.maxTurnsBeforeInjection;
        this._numberToSpawnOnStartup = this.numberToSpawnOnStartup;

        this.computeNextInjectTurn();
    }

    computeNextInjectTurn() {
        if (this._maxTurnsBeforeInjection > 0) {
            this._nextInjectTurn =
                this._turnCount +
                RNG.getUniformInt(
                    this._minTurnsBeforeInjection,
                    this._maxTurnsBeforeInjection
                );
        } else {
            this._nextInjectTurn = -1;
        }
    }

    startGame(puzzle: Puzzle) {
        puzzle.registerTurnCompleteCallback(this._turn);
        puzzle.registerResetGameCallback(this._reset);
        this._turnCount = 0;

        // this._minTurnsBeforeInjection = this.minTurnsBeforeInjection;
        // this._maxTurnsBeforeInjection = this.maxTurnsBeforeInjection;
        // this._numberToSpawnOnStartup = this.numberToSpawnOnStartup;

        // this.computeNextInjectTurn();

        if (this._numberToSpawnOnStartup > 0) {
            for (let x = 0; x < this._numberToSpawnOnStartup; x++) {
                this._inject(puzzle);
            }
        }
    }

    overrideSettings(minTurns: number, maxTurns: number, spawnAtStartup: number) {
        this._minTurnsBeforeInjection = minTurns;
        this._maxTurnsBeforeInjection = maxTurns;
        this._numberToSpawnOnStartup = spawnAtStartup;
    }

    private _inject(puzzle: Puzzle) {
        let bestRow = -1;
        let bestCol = -1;
        let bestWeight = 0.0;

        for (let x = 0; x < BlobInjector.SEARCH_SIZE; x++) {
            // time to inject
            const col = RNG.getUniformInt(0, puzzle.lanes.length);
            const row = RNG.getUniformInt(0, puzzle.getHighestOccupiedRow(col) + 1);
            const obj = puzzle.getObject(row, col);
            if (obj && !obj.isFruit && !obj.loaded) {
                const weight = PuzzleUtils.computeSpawnQuality(
                    row,
                    col,
                    this.prefabTag,
                    puzzle
                );
                if (weight > bestWeight) {
                    bestRow = row;
                    bestCol = col;
                    bestWeight = weight;
                    if (weight == 1.0) {
                        // perfect spot, stop searching
                        break;
                    }
                }
            }
        }

        if (bestWeight > 0.0 && bestWeight > this.minimumRequiredQuality) {
            const obj = puzzle.getObject(bestRow, bestCol);

            const payload = BlobPrefabs.instance.spawn(this.prefabToInject, null, true);

            obj.loadObject(payload);
            //obj.hiccup();

            // if (spawnEffect) {
            //     Instantiate(spawnEffect, obj.transform.position, obj.transform.rotation);
            // }

            this.computeNextInjectTurn();
        }
    }

    private _reset = (puzzle: Puzzle) => {
        this._minTurnsBeforeInjection = this.minTurnsBeforeInjection;
        this._maxTurnsBeforeInjection = this.maxTurnsBeforeInjection;
        this._numberToSpawnOnStartup = this.numberToSpawnOnStartup;
        this._turnCount = 0;

        puzzle.unregisterTurnCompleteCallback(this._turn);
        puzzle.unregisterResetGameCallback(this._reset);
    };

    private _turn = (puzzle: Puzzle) => {
        this._turnCount++;
        let inLevelWindow = true;

        if (this.maximumLevelToSpawn > 0 || this.minimumLevelToSpawn > 0) {
            const level = puzzle.level;
            if (
                (this.maximumLevelToSpawn > 0 && level > this.maximumLevelToSpawn) ||
                level < this.minimumLevelToSpawn
            ) {
                inLevelWindow = false;
            }
        }

        if (
            inLevelWindow &&
            this._nextInjectTurn >= 0 &&
            this._turnCount >= this._nextInjectTurn
        ) {
            this._inject(puzzle);
        }
    };
}
